var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQ5B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M224.78 121.399V159.489C193.05 177.799 155.16 202.879 123.43 221.199V177.639C155.29 163.309 192.92 135.749 224.78 121.399Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0499 117.659C40.6499 108.599 57.2399 99.5395 73.8399 90.4695C96.1399 122.699 112.7 145.78 135 178L237.16 122.909C169.26 29.7195 242.02 129.059 169.26 29.7195L73.8399 70.6695C57.2399 86.3295 40.6499 101.989 24.0499 117.649V117.659Z",
    fill: "#29A063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0499 117.659L123.62 177.929L73.8299 90.4695L24.0399 117.659H24.0499Z",
    fill: "#A7CFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0499 117.66L123.62 177.93L71.5999 86.4895L24.0499 117.65V117.66Z",
    fill: "#B2E8C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.84 111.459C16.57 113.529 20.31 115.599 24.04 117.659L71.7 86.9395L123.61 177.939H135.18L73.83 70.6995C53.5 84.2895 33.17 97.8694 12.84 111.459Z",
    fill: "#72D09A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.39 91.2195L117.56 102.419L137.56 131.689L161.26 119.219L142.39 91.2195Z",
    fill: "#FECECA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.13 121.959L138.1 93.1595L142.4 91.2095L161.3 119.209L156.12 121.969L156.13 121.959Z",
    fill: "#FEE4E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.2 73.1295L155.66 84.4695L174.68 112.17L198.58 99.3495L179.2 73.1295Z",
    fill: "#FECECA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.58 101.999L174.8 75.2494L179.24 73.1494L198.57 99.3194L193.58 102.009V101.999Z",
    fill: "#FEE4E2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M155.67 84.4695L156.48 84.0895L158.83 89.0995L155.66 84.4695H155.67Z",
    fill: "#FECECA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M171.52 107.569L172.07 107.299L174.68 112.179L171.51 107.569H171.52Z",
    fill: "#FECECA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.55 131.619L135 126.709L150.4 118.719L137.86 99.3495L120.78 107.049L118.51 102.009L139.92 92.3595L158.34 120.829L137.54 131.629L137.55 131.619Z",
    fill: "#F97E73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.56 102.439L118.75 101.899L120.75 107.029L117.57 102.439H117.56Z",
    fill: "#FECECA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.42 127.069L135.05 126.699L137.56 131.659L134.42 127.069Z",
    fill: "#FECECA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.69 112.159L172.06 107.299L187.71 98.8495L175.15 81.2295L158.83 89.1095L156.43 84.1295L176.95 74.2295L195.86 100.739L174.7 112.169L174.69 112.159Z",
    fill: "#F97E73"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0499 117.659L123.63 177.939L123.41 221.199L24.9099 155.469L24.0499 117.659Z",
    fill: "#B2E8C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ5B);
export default __webpack_public_path__ + "static/media/q5b.8a172138a4310b756a0ae6e66e2670f0.svg";
export { ForwardRef as ReactComponent };